import React, { useState, useEffect } from "react";
import ImageLoader from "../ImageLoader";

const CompanyLogos = () => {
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  const [loadedImages, setLoadedImages] = useState(new Set<string>());

  // Memoize companies to prevent recreation on each render
  const companies = React.useMemo(
    () => [
      {
        name: "DoorDash",
        logo: "/company-logos/doordash.webp",
        darkLogo: "/company-logos/doordash-dark.webp",
      },
      {
        name: "Zapier",
        logo: "/company-logos/zapier.webp",
        darkLogo: "/company-logos/zapier-dark.webp",
      },
      {
        name: "Y Combinator",
        logo: "/company-logos/yc.webp",
        darkLogo: "/company-logos/yc-dark.webp",
      },
      {
        name: "Method",
        logo: "/company-logos/method.webp",
        darkLogo: "/company-logos/method-dark.webp",
      },
    ],
    []
  );

  // Using useMemo to avoid recreating the company set on every render
  const totalExpectedImages = React.useMemo(
    () => companies.length * 2,
    [companies.length]
  );

  const handleImageLoad = React.useCallback(
    (imageName: string) => {
      setLoadedImages((prev) => {
        const newSet = new Set(prev);
        newSet.add(imageName);

        // Check if all images (both light and dark) are loaded
        if (newSet.size === totalExpectedImages) {
          setAllImagesLoaded(true);
        }

        return newSet;
      });
    },
    [totalExpectedImages]
  );

  return (
    <section className="py-0">
      <div className="text-center mb-1">
        <h2 className="text-3xl font-bold m-0 font-mono">
          Trusted by top companies
        </h2>
      </div>

      <div
        className={`logos-container bg-background/50 pt-2 px-4 pb-4 shadow-none border-none transition-opacity duration-500 ${
          allImagesLoaded ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 items-center justify-items-center max-w-6xl mx-auto mb-8 mt-0">
          {companies.map((company) => (
            <div
              key={company.name}
              className="logos-item w-full max-w-[200px] h-2 relative flex items-center justify-center"
            >
              <div className="block dark:hidden w-full h-full">
                <ImageLoader
                  src={company.logo}
                  alt={`${company.name} logo`}
                  className="logos-image object-contain max-h-full max-w-full rounded-none shadow-none"
                  priority={true}
                  width={200}
                  height={48}
                  onLoad={() => handleImageLoad(`${company.name}-light`)}
                />
              </div>

              <div className="hidden dark:block w-full h-full">
                <ImageLoader
                  src={company.darkLogo}
                  alt={`${company.name} dark logo`}
                  className="logos-image object-contain max-h-full max-w-full rounded-none shadow-none"
                  priority={true}
                  width={200}
                  height={48}
                  onLoad={() => handleImageLoad(`${company.name}-dark`)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyLogos;
